'use strict';

const allWorkDones = state => {
  return state.workDones.slice();
};

export default {
  allWorkDones
};
